import { mapActions, mapGetters } from "vuex";

import VFacebookLogin from "vue-facebook-login-component";

export default {
    name: "facebook-widget",
    props: {
        type: {
            type: String,
            default: "sing-in",
        },
    },
    data() {
        return {
            facebook: {
                FB: {},
                model: {},
                appId: process.env.VUE_APP_FACEBOOK_IDENTITY,
            },
            updateRender: true,
        };
    },
    computed: {
        labelByType() {
            switch (this.type) {
                case "linked": {
                    return this.$t("linked");
                }
                default: {
                    return "Facebook";
                }
            }
        },
    },
    components: {
        VFacebookLogin,
    },
    methods: {
        ...mapActions({
            auth: `auth/AUTH_WITH_SOCIAL`,
            linkAccount: `userContacts/LINK_ACCOUNT`,
            fetchUser: `user/GET_USER_DATA`,
        }),
        ...mapGetters({ user: "user/user" }),
        getUserData() {
            const { api } = this.facebook.FB;
            api(
                "/me",
                { fields: "id, name, email, first_name, last_name" },
                (profile) => {
                    const token = this.facebook.FB.getAccessToken();

                    if (this.type === "sing-in") {
                        const params = {
                            full_name: profile.name,
                            email: profile.email,
                            image: `https://graph.facebook.com/${profile.id}/picture?type=square`,
                            isSocial: true,
                            token: token,
                            provider: "facebook",
                            country_id: 1,
                        };

                        this.auth(params)
                            .then(() => {
                                this.$toasted.success(this.$t("successAuth"));
                                this.$toasted.success(this.$t("loadData"));
                                this.fetchUser().then(() => {
                                    let userLang = "en";
                                    if (this.user?.languageInterface?.value) {
                                        userLang = this.user.languageInterface.value;
                                    }

                                    // this.$router.push({ name: "courses" });
                                    const redirect =
                                        this.$route.query.redirect ||
                                        `/${userLang}/courses`;
                                    this.$router.push(redirect);
                                });
                            })
                            .catch((error) => {
                                if (error.response.status === 418) {
                                    this.$toasted.error(
                                        error.response.data.data.error.message
                                    );
                                }
                                // if (error.response.status === 422) {
                                //     this.$router.replace({
                                //         name: "login",
                                //         query: { ...params },
                                //     });
                                // }
                            });
                    }
                    if (this.type === "linked") {
                        const params = {
                            full_name: profile.name,
                            email: profile.email,
                            isSocial: true,
                            token: token,
                            provider: "facebook",
                            country_id: 1,
                        };
                        this.linkAccount(params)
                            .then(() => {
                                this.$toasted.success(this.$t("successLinkedAccount"));
                                this.handleLogout();
                            })
                            .catch((error) => {
                                if (error.response.status === 409) {
                                    this.$toasted.error(
                                        error.response.data.error.message_key
                                    );
                                }
                            });
                    }
                }
            );
        },
        handleSdkInit({ FB }) {
            FB.init({
                xfbml: true,
                version: "v2.8",
                appId: process.env.VUE_APP_FACEBOOK_IDENTITY,
                status: false,
                cookie: false,
            });
            this.facebook.FB = FB;
        },
        created() {},
        mounted() {
            this.handleLogout();
        },
        handleConnect() {},
        handleLogout() {
            this.facebook.FB.getLoginStatus((response) => {
                if (response.status === "connected") {
                    this.facebook.FB.logout(() => {
                        this.updateRender = false;
                        setTimeout(() => {
                            this.updateRender = true;
                        }, 10);
                    });
                }
            });
        },
        login() {
            this.getUserData();
        },
        handleClick() {
            // eslint-disable-next-line
        },
    },
    destroyed() {
        if (this.type === "linked") {
            return;
        }

        this.handleLogout();
    },
};
